module.exports = __webpack_public_path__ + "static/img/1-4.d597ce3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/1-4.jpg
// module id = 5fsA
// module chunks = 25